export default function addProtocol (url: string) {
  if (!url) throw TypeError('URL couldn\'t be undefined')
  return /^http/.test(url) ? url : window.location.protocol + '//' + url
}
